// extracted by mini-css-extract-plugin
export default {"tooltip":"ChartItem_tooltip__X7m6S"};